<template>
	<!-- 
		Displays info regarding the fyndware class of a product.
		
		If the fyndware has a product description, it will be displayed here.
		Otherwise some general info about the fyndware class will be displayed.
	-->
	<div class="panel panel-body" style="padding: 0" v-if="product.isFyndware">
		<div class="fyndware-background">
			<div class="d-flex">
				<img :src="priceTagIconSrc" class="fyndware-image" alt="special price" />
				<span class="fyndware-heading text-highlight">Fyndvara</span>
				<div v-if="product.fyndwareClass" class="panel panel-body ml-5 mb-0 fyndware-class">
					<span class="text-highlight " :class="fyndwareClass">{{ fyndwareClassText + (product.fyndwareClass.condition ? ':' : '') }}</span>
					<span class="text-highlight" v-if="product.fyndwareClass.condition"> {{ product.fyndwareClass.condition }}</span> 
				</div>
			</div>
			<div class="mt-4">
				<div v-if="product.description && product.description.length">
					<product-description
						:html="product.description"
						:product="product"
					/>
					<div class="fyndware-paragraph text-highlight">
						 Samtliga fyndvaror kommer med 30 dagars öppet köp (60 dagar för medlemmar) och täcks av samma skydd som konsumentköplagen ger övriga produkter.
					</div>
				</div>
				<i v-else-if="product.fyndwareClass">
					{{ product.fyndwareClass.description }}
					<strong>Samtliga fyndvaror kommer med 30 dagars öppet köp (60 dagar för medlemmar) och täcks av samma skydd som konsumentköplagen ger övriga produkter.</strong>
				</i>
				<product-description
					v-if="product.isFyndware"
					class="fyndware-paragraph"
					:html="fyndwareDescription"
					:product="product"
				/>
				<i v-else>
					Fyndvaror är produkter som säljs till ett reducerat pris.
					Anledningen till detta är att de kan ha öppnats, använts, 
					vara returexemplar från distributören eller ha ett trasigt emballage.
				</i>
			</div>
			<div v-if="showInEarDisclaimer" class="fyndware-paragraph">
				<strong>*</strong> In-ear-hörlurar som följer med till mobiler och surfplattor kan saknas då du köper en fyndvara. 
				Vi kasserar hörlurarna om de är använda, av hygienskäl.
			</div>
			<div class="fyndware-paragraph">
				För mer information om klassystemet se
				<router-link :to="{ name: 'info', params: { id: 11, name: 'Fyndvaror' }}">Fyndvaror</router-link>
			</div>
		</div>
	</div>
</template>
<script>
import { convertToCdnUrl, getFyndwareCssClass } from 'utils';

export default {
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	computed: {
		productCategory () {
			return this.product.categories[0];
		},
		showInEarDisclaimer () {
			// Dirty hax to show a disclaimer for tablets and mobiles.
			const categories = [
				4803, // Fyndvaror -> Mobiles -> Mobiltelefoner.
				4817, // Fyndvaror -> Datorer & Tillbehör -> Surf- & Läsplattor.
				4932, // Fyndvaror -> Mobil -> Surf- & Läsplattor.
				16013, // Fyndvaror -> Apple -> iPad.
			];
			return categories.includes(this.productCategory.id);
		},
		priceTagIconSrc () {
			return convertToCdnUrl('/img/icons/categories/prislapp.svg');
		},
		fyndwareClass () {
			return getFyndwareCssClass(this.product);
		},
		fyndwareClassText () {
			return this.product.fyndwareClass.name.toUpperCase();
		},
		fyndwareDescription() {
			// Return the first description found starting from the bottom
			const categories = this.product.mainCategoryPath.reverse();

			for(let i = 0; i < categories.length; i++) {
				if(categories[i].fyndwareDescription) {
					return categories[i].fyndwareDescription;
				};
			}
		}
	},
};
</script>